import * as React from 'react';
import { useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import LocalHospitalOutlinedIcon from '@mui/icons-material/LocalHospitalOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import reicon from '../../assets/main/reicon.png';
import { useNavigate } from 'react-router-dom';
import * as util from '../../utils/util';
import api from '../../utils/api';
import Chip from '@mui/material/Chip';
import Skeleton from '@mui/material/Skeleton';

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

const TopMan = styled('img')({
  marginLeft: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

const topMan = {
  position: 'relative' as const,
  top: '74px',
  right: '14px',
};

const topContainer = {
  height: 295,
  backgroundImage: `url(${'../../src/assets/main/mainTop.png'})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
};

const MainMedical = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);

  // ✅ 더미 1개 넣지 말고 빈 배열 (불필요한 타입/렌더 복잡도 감소)
  const [reservationList, setReservationList] = React.useState<any[]>([]);

  const userCusId = util.strNull((window.localStorage as any).userCusID);
  const hasUser = userCusId !== '';

  useEffect(() => {
    setLoading(true);

    if (hasUser) {
      api
        .post('customer/api/v1/CU_004_001', { cusId: userCusId })
        .then((res: any) => {
          const nowYear = new Date().getFullYear().toString();
          setReservationList(
            (res?.data?.inspection ?? []).filter(
              (v: any) =>
                v.reservationStatus.code >= 0 &&
                (util.strNull(v.ipDate) !== '' ? v.ipDate.startsWith(nowYear) : v.firstWishDate.startsWith(nowYear))
            )
          );
        })
        .catch((error: any) => console.log(error))
        .finally(() => setLoading(false));
    } else {
      const t = window.setTimeout(() => setLoading(false), 500);
      return () => window.clearTimeout(t);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleRootClick = () => {
    if (!hasUser || reservationList.length < 1) navigate('../reservation');
  };

  return (
    <React.Fragment>
      <List
        sx={{ width: '100%', p: '5px 0', bgcolor: '#fff', borderRadius: '20px', mt: 1 }}
        onClick={handleRootClick}
      >
        <ListItem alignItems="center">
          <Stack sx={{ width: '100%' }}>
            {/* 헤더 */}
            <Stack direction={'row'} alignItems={'center'} spacing={2} mb={1}>
              {/* ✅ Box 대신 div */}
              <div
                style={{
                  backgroundColor: '#FEF8F5',
                  width: 64,
                  height: 64,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {loading ? (
                  <Skeleton animation="wave" variant="circular" width={64} height={64} />
                ) : (
                  <Avatar alt="" src={reicon} sx={{ borderRadius: 0 }} />
                )}
              </div>

              {loading ? (
                <Stack direction={'column'} sx={{ textAlign: 'center', width: '50%' }} justifyContent="center">
                  <Skeleton animation="wave" variant="rounded" height={21} width="100%" sx={{ borderRadius: 3 }} />
                  <Skeleton animation="wave" variant="rounded" height={21} width="100%" sx={{ borderRadius: 3, my: 1 }} />
                </Stack>
              ) : (
                <Stack direction={'column'}>
                  <Typography sx={{ fontSize: 14, color: '#666' }}>건강검진 편리하게 예약하기</Typography>
                  <Typography sx={{ fontSize: 18, fontWeight: 700, m: '5px 0', color: '#555' }}>건강검진 예약</Typography>
                </Stack>
              )}
            </Stack>

            {/* 본문 */}
            {!hasUser || reservationList.length < 1 ? (
              <div>
                {loading ? (
                  <Stack sx={{ width: '80%', margin: '0 auto' }} justifyContent="center" alignItems={'center'}>
                    <Skeleton animation="wave" variant="rounded" height={21} width="100%" sx={{ borderRadius: 3 }} />
                  </Stack>
                ) : (
                  <Stack direction={'row'} justifyContent={'center'} onClick={() => navigate('/reservation')}>
                    <EventBusyIcon sx={{ fontSize: 18, color: '#aaa', m: '3px 10px 0 0' }} />
                    <Typography sx={{ fontSize: 14, color: '#EF8322' }}>예약 정보가 없습니다</Typography>
                  </Stack>
                )}
              </div>
            ) : (
              <>
                {reservationList.slice(0, 5).map((item: any, index: number) => (
                  <div key={item.rsvId || index}>
                    {loading ? (
                      <div style={{ display: 'flex', textAlign: 'center', justifyContent: 'center' }}>
                        <Skeleton animation="wave" variant="rounded" height={95} width="100%" sx={{ borderRadius: 3 }} />
                      </div>
                    ) : (
                      <Stack
                        className="reservationList"
                        direction={'column'}
                        justifyContent={'center'}
                        sx={{
                          p: 0,
                          bgcolor: '#f9f9f9',
                          borderRadius: 3,
                          mt: 1,
                          '&.reservationList:nth-child(n+1)': { py: 1, px: 2 },
                        }}
                        onClick={() =>
                          navigate('/reservation/SetFinishDetail', {
                            state: { hoImage: item.hoImage, rsvId: item.rsvId, url: 'ReservationView' },
                          })
                        }
                      >
                        <Stack direction={'row'}>
                          <PersonOutlineOutlinedIcon sx={{ fontSize: 18, color: '#aaa', m: '3px 10px 0 0' }} />
                          <Typography sx={{ fontSize: 16, color: '#777', mt: '0px', fontWeight: 700 }}>
                            {item.famName}
                            {util.strNull(item.famGrade) !== '' ? (
                              <Typography component={'span'} sx={{ fontSize: 14, color: '#555', mt: '2px', ml: 0.5 }}>
                                {'(' + item.famGrade + ')'}
                              </Typography>
                            ) : null}
                          </Typography>
                        </Stack>

                        <Stack direction={'row'} my={0.5}>
                          <EventAvailableOutlinedIcon sx={{ fontSize: 18, color: '#aaa', m: '4px 10px 0 0' }} />
                          <Typography sx={{ fontSize: 16, fontWeight: 700, color: '#ff666c' }}>
                            {util.strNull(item.ipDate) !== '' ? item.ipDate : item.firstWishDate}
                          </Typography>

                          {util.strNull(item.reservationStatus.name) === '' ? null : item.reservationStatus.code <= 0 ? (
                            <Chip label={item.reservationStatus.name} size="small" sx={{ ml: 2, bgcolor: '#f18322', color: '#fff' }} />
                          ) : (
                            <Chip
                              label={item.reservationStatus.name}
                              size="small"
                              variant="outlined"
                              sx={{ ml: 2, bgcolor: '#fff', color: '#f18322', borderColor: '#f18322' }}
                            />
                          )}
                        </Stack>

                        <Stack direction={'row'}>
                          <LocalHospitalOutlinedIcon sx={{ fontSize: 18, color: '#aaa', m: '4px 10px 0 0' }} />
                          <Typography sx={{ fontSize: 14, color: '#555', mt: '2px' }}>{item.hoName}</Typography>
                        </Stack>
                      </Stack>
                    )}
                  </div>
                ))}
              </>
            )}
          </Stack>
        </ListItem>
      </List>
    </React.Fragment>
  );
};

export default MainMedical;
